
<app-e-form-viewer id="eFormViewer" 
    *ngIf="showViewer" 
    [configInput]="config" 
    (valueChanged)="valueChanged($event)" 
    (renderCompleted)="renderCompleted()"
    (initialized)="initializedEFormViewerEvent()"  
    [masterId]="masterId"
    [designPageIndex]="designPageIndex">
    <img src="./assets/images/edit design page.png" class="editDesignPageButon" (click)="editPageClick()" aria-label="Edit Design Page Button" *ngIf="userCanEditPage"/>
</app-e-form-viewer>